module.exports =
  '_SESSION':
    'NEW':
      'TITLE': '@:_SESSION.NEW.SIGN_IN'
      'SIGN_IN': 'ログイン'
      'LOCK_ACCOUNT': 'アカウント保護のため、ログインをロックしました。しばらくしてから再度お試しください。'
      'EMAIL_ADDR': 'メールアドレス'
      'PASSWORD': 'パスワード'
      'FORGOT_PASSWORD': 'パスワードを忘れた方はこちら'
      'LOGIN_GUIDE': 'ログインアカウントは、アプリ／Web共通です。
        <br>YOUR GOLF または GOLF NETWORK PLUS アプリを
        <br>既にお使いの方は、同じアカウントでログインできます。'
      'LOGIN_GUIDE_TINY': 'ログインアカウントは、アプリ／Web共通です。
        <br>YOUR GOLF または GOLF NETWORK PLUS アプリを
        <br>既にお使いの方は
        <br>同じアカウントでログインできます。'
      'ERROR': 'メールアドレスとパスワードの組み合わせが見つかりません。ご確認の上再度お試し下さい。'
      'SIGN_UP_SUP': 'YOUR GOLF または GOLF NETWORK PLUS アプリを
        <br>使ったことがない方は、こちらから新規登録しご利用ください。'
      'SIGN_UP_SUP_TINY': 'YOUR GOLF または
        <br>GOLF NETWORK PLUS アプリを
        <br>使ったことがない方は,<br>こちらから新規登録しご利用ください。'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/session/i18n/ja.coffee